import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router";
import { AppLoader } from "../components/AppLoader";
import Main from "../Main";
import Login from "../pages/Login";
import Register from "../pages/Register/index";
import ResetPassword from "../pages/ResetPassword/index";
import { appConfigAction } from "../store/actions/app";

export default function Router() {
  const dispatch = useDispatch();
  const appLoading = useSelector((state) => state.app.loading);

  useEffect(() => {
    dispatch(appConfigAction());
  }, [dispatch]);

  if (appLoading) return <AppLoader />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/*" element={<Main />} />
    </Routes>
  );
}
